import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

type QueryResponse = {
  status: number
  data: {tags: {tag: string, contacts: number}[]};
};

export const createListTagsKey = (additional: any[] = []) => [
  'list-tags',
  ...additional,
];

export const useListTagsQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while Listing WhatsApp Tags',
    endpoint: `/api/admin/whatsapp/contacts/tags`,
  });

  return useQuery({
    queryKey: createListTagsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};